import { FC } from 'react';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { TelegramBotDrop } from './telegramBotDrop/TelegramBotDrop';
import { TelegramBotSettings } from './telegramBotSettings/TelegramBotSettings';

import css from './TelegramBotPage.module.css';

import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { useTabs } from 'v2/hooks/useTabs';
import { TelegramBotTab } from 'v2/pages/telegramBot/constants';

export const TelegramBotPage: FC = () => {
  const { activeTab, onTabChange } = useTabs<TelegramBotTab>(TelegramBotTab.SETTINGS);

  return (
    <PageLayout className={css.telegramBotPage} overflow="hidden">
      <PageTitle>Telegram Bot Settings</PageTitle>

      <Tabs value={activeTab} onChange={(_, v) => onTabChange(v)}>
        <Tab value={TelegramBotTab.SETTINGS} label="Settings" />
        <Tab value={TelegramBotTab.DROP} label="Drop" />
      </Tabs>

      <div className={css.telegramBotPageContent}>
        {activeTab === TelegramBotTab.SETTINGS && <TelegramBotSettings />}
        {activeTab === TelegramBotTab.DROP && <TelegramBotDrop />}
      </div>
    </PageLayout>
  );
};
